import { JSX } from 'react';
import { ChildrenAnimalMotif } from '@ahc-digital/component-library';
import { CreateChildrensAnimalMotif } from './C46ChildrensAnimalMotif.service';
import { C46ChildrensAnimalMotifProps } from './C46ChildrensAnimalMotif.types';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { GetServerSideComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';

const Default = (props?: C46ChildrensAnimalMotifProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );
  const randomAnimalIndex = Number(props?.params?.randomAnimalIndex ?? 0);

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  return (
    <ChildrenAnimalMotif
      {...CreateChildrensAnimalMotif(props)}
      randomAnimalIndex={randomAnimalIndex}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C46ChildrensAnimalMotifProps>(Default);

export const getServerSideProps: GetServerSideComponentProps = async () => {
  const randomAnimalIndex = Math.floor(Math.random() * 5);
  return {
    params: {
      randomAnimalIndex: String(randomAnimalIndex),
    },
  };
};
